import * as ko from "knockout";
import Bao from "./../services/bao-service";
import ConfigurationItemViewModel from "./configuration-item";
import BaoDialogViewModel from "./../factories/bao-dialog";
import "./../bindings/bao-number-box";
function CustomerViewModel(tabPage) {
    var self = this;
    ConfigurationItemViewModel.call(this, tabPage);
    self.CompleteCheck = function () {
        var isComplete = true;
        if (self.CustomerNumberSAP() == "") {
            isComplete = false;
        }
        if (Bao.Utils.String.IsNullOrWhitespace(self.Name1())) {
            isComplete = false;
        }
        if (self.ConfigurationItemTypeId() == null) {
            isComplete = false;
        }
        if (self.ConfigurationItemStatusId() == null) {
            isComplete = false;
        }
        if (self.CountryId() == null) {
            isComplete = false;
        }
        if (self.SupportingLocationId() == null) {
            isComplete = false;
        }
        if (self.CustomerCodeIsMandatory()) {
            if (Bao.Utils.String.IsNullOrWhitespace(self.Name2())) {
                isComplete = false;
            }
        }
        if (!isComplete) {
            new BaoDialogViewModel(Bao.Session.ApplicationName, Bao.Session.GetMessage("msgFillMandatorFields"), "info");
        }
        return isComplete;
    };
    self.ResetAccountAssignment = function (row) {
        self.AccountAssignment(null);
    };
}
;
Bao.inherit(CustomerViewModel, ConfigurationItemViewModel);
CustomerViewModel.prototype.DeleteMessageKey = "msgDeleteCustomer";
CustomerViewModel.prototype.RefreshUrl = "ConfigurationItem/GetCustomer";
CustomerViewModel.prototype.SaveUrl = "ConfigurationItem/SaveCustomer";
CustomerViewModel.prototype.DeleteUrl = "ConfigurationItem/DeleteCustomer";
CustomerViewModel.prototype.PermissionForward = "CustomerMoveForwardSearch";
CustomerViewModel.prototype.PermissionBackward = "CustomerMoveBackwardSearch";
CustomerViewModel.prototype.PermissionRefresh = "CustomerRefresh";
CustomerViewModel.prototype.PermissionSave = "CustomerSave";
CustomerViewModel.prototype.PermissionDelete = "CustomerDelete";
CustomerViewModel.prototype.ConfigurationItemTypeKeyCategory = "Customer";
CustomerViewModel.prototype.PermissionAuditTrail = "CustomerAudit";
export default CustomerViewModel;